module.exports = __webpack_public_path__ + "static/media/tgs.fe4ef481.jpg";